import React from 'react';

const TooltipCell = ({ tooltip, children }) => (
  <td title={tooltip}>
    {children}
  </td>
);

export default TooltipCell;
